import { clamp } from "@theme/utils";

/**
 * Pagination Track Start
 *
 * Compute the start index of the visible window given a 0-based active index
 *
 * Return the 0-based start index of a sliding window that:
 * - shows `windowSize` items out of `total`
 * - tries to keep `activeIndex` centered
 * - never scrolls past the start or end
 */
export const paginationTrackStart = (
  activeIndex: number,
  total: number,
  windowSize: number,
): number => {
  if (total <= 0 || windowSize <= 0) return 0;

  const half = Math.floor(windowSize / 2);
  const rawStart = activeIndex - half;
  const maxStart = Math.max(0, total - windowSize);

  return clamp(maxStart, 0, rawStart);
};
